import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { toastSyncSuccess } from 'src/utils/syncToast'
import { useAuth } from 'src/contexts/auth'
import { LotController } from 'src/controllers/lot.controller'
import { LotParams } from 'src/domain/lot'

const loteController = new LotController()

export function useUpdateLot() {
  const { userFarm: farmId } = useAuth()

  return useMutation({
    mutationFn: (data: LotParams) => loteController.updateLot(farmId!, data),
    onSuccess: (_, payload) => {
      toastSyncSuccess(`Lote ${payload.id ? 'atualizado' : 'criado'} com sucesso!`)
    },
    onError: (_, payload) => {
      toast.error(`Erro ao ${payload.id ? 'atualizar' : 'criar'} lote`)
    }
  })
}
